function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerCareKeys from '../../../../../../locales/keys';
import { FREQUENCY_TYPES } from 'invision-core/src/constants/frequency.types.constants';
import i18n from 'invision-core/src/components/i18n/i18n';
import pluck from 'ramda/src/pluck';
import { retrieveOfferingsMetadata } from 'invision-core/src/components/metadata/offerings/offerings.actions';
import { OfferingMetadataByIdSelector, OfferingMetadataPricingPlansSelector } from 'invision-core/src/components/metadata/offerings/offerings.selectors';
var FullCartRenewalScheduleComponent = /*#__PURE__*/function () {
  function FullCartRenewalScheduleComponent($ngRedux) {
    _classCallCheck(this, FullCartRenewalScheduleComponent);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      CustomerCareKeys: CustomerCareKeys
    });
  }
  return _createClass(FullCartRenewalScheduleComponent, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          offeringMetadataById: OfferingMetadataByIdSelector(store),
          offeringMetadataPricingPlans: OfferingMetadataPricingPlansSelector(store)
        };
      };
      var controllerActions = {
        retrieveOfferingsMetadata: retrieveOfferingsMetadata
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.fetchOrderDetails = function () {
        var orderIdList = pluck('OfferingId', _this.renewalSchedule.OffCycleNextRenewalScheduleDetails);
        _this.actions.retrieveOfferingsMetadata(orderIdList);
      };
      this.fetchOrderDetails();
      this.getBillingPeriod = function (pricingPlanId) {
        var pricingPlanDetails = _this.state.offeringMetadataPricingPlans[pricingPlanId];
        switch (pricingPlanDetails.DurationPeriodType) {
          case FREQUENCY_TYPES.DAILY:
            return i18n.translate(CustomerCareKeys.FULL_CART.DAILY);
          case FREQUENCY_TYPES.HOURLY:
            return i18n.translate(CustomerCareKeys.FULL_CART.HOURLY);
          case FREQUENCY_TYPES.MONTHLY:
            return i18n.translate(CustomerCareKeys.FULL_CART.MONTHLY);
          case FREQUENCY_TYPES.WEEKLY:
            return i18n.translate(CustomerCareKeys.FULL_CART.WEEKLY);
          case FREQUENCY_TYPES.YEARLY:
            return i18n.translate(CustomerCareKeys.FULL_CART.YEARLY);
          default:
            return '';
        }
      };
    }
  }, {
    key: "onExpandToggleItems",
    value: function onExpandToggleItems() {
      this.onExpandToggle();
    }
  }]);
}();
export default {
  bindings: {
    currency: '<',
    isEdit: '<',
    isExpanded: '<',
    renewalSchedule: '<',
    onExpandToggle: '&'
  },
  template: require('./full.cart.renewal.schedule.html'),
  controller: FullCartRenewalScheduleComponent,
  controllerAs: 'FullCartRenewalScheduleController'
};